import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { RequestModel } from 'src/app/shopping-cart/request-model.model';
import { IndProvModalComponent } from 'src/app/main/ind-prov-modal/ind-prov-modal.component';
import { NavigationExtras, Router } from '@angular/router';
import { DentPracModalComponent } from 'src/app/main/dent-prac-modal/dent-prac-modal.component';
import { EventService } from 'src/app/main/event-service/event.service';

@Component({
  selector: 'app-duplicate-modal',
  templateUrl: './duplicate-modal.component.html',
  styleUrls: ['./duplicate-modal.component.scss']
})
export class DuplicateModalComponent {
  @ViewChild('duplicate', { static: true }) public templateref: TemplateRef<any>;
  @ViewChild(IndProvModalComponent) editModal: IndProvModalComponent;
  @ViewChild(DentPracModalComponent) editGroupModal: DentPracModalComponent;

  modalRef: BsModalRef;
  request: RequestModel;
  
  constructor(private modalService: BsModalService, private eventService: EventService) {}

  public openModalWithClass(request: RequestModel): void {
    this.request = request;
    this.modalRef = this.modalService.show(
      this.templateref,
      Object.assign({}, { class: 'modal-lg modal-dialog-centered' })
    );
  }

  public duplicates(): void {
    this.modalService._hideModal();
    
    this.request.providerType === 'PROVIDER'
      ? this.editModal.openModalWithClass(this.request.requestType)
      : this.editGroupModal.openModalWithClass(this.request.requestType);

    this.request.name = '';
    this.request.lastName = '';
    this.request.requestDetails = '';
    this.request.middleInitial = '';
    this.request.providerID = '';
    this.request.taxID = '';
    this.request.NPI = '';
    this.request.caqhId = '';
    this.request.optDocs = [];
    this.request.doc = null;

    this.eventService.requestModel = this.request;
  }
}
